<template>
    <Select :model-value="selectedTeamId" @update:model-value="showByTeam">
        <SelectTrigger>
            <SelectValue class="px-2" :placeholder="$t('bookings.by_team')" />
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                <SelectItem
                    v-for="team of teams"
                    :key="team.id"
                    class="gap-3 px-4"
                    :value="team.id.toString()"
                >
                    {{ team.name }}
                </SelectItem>
            </SelectGroup>
        </SelectContent>
    </Select>
</template>

<script setup lang="ts">
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { ref } from "vue";
import { Team } from "../../Teams/types/Team";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";

const props = defineProps<{
    teams: Team[];
    selectedTeam: Team;
}>();

const selectedTeamId = ref<string>(props.selectedTeam.id.toString());

const showByTeam = (teamId: string) => {
    router.visit(
        route("app.teams.reports.index", {
            team: teamId,
        }),
    );

    selectedTeamId.value = teamId;
};
</script>
